
// src/connects/template-form-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'
import find from 'lodash/find'
import filter from 'lodash/filter'

export const mapStateToProps = (state, ownProps) => {
  return {
    isUpdating: state.templates.isUpdating,
    isUpdateFailed: state.templates.isUpdateFailed,
    template:  ownProps.cloneTemplate || ownProps.template_id && state.templates.items && find(state.templates.items, (item)=> item.template_id == ownProps.template_id),
  }
}

function cloneTemplate(props, suffix) {
  if(props)
    return props.name + ' ' + suffix;
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    validateAndSubmit: (props, event = undefined) => {
      if (event && event.preventDefault)
        event.preventDefault();
      
      validate(props.ui, {
        name: { rule: 'isRequired' },
      }, (errors, nextUI) => {
        props.ui.handlers && props.ui.handlers.getValue((template) => {
          template = template.replace(/<div><\/div>/g, '')
          if (!template || template.length == 0) {
            nextUI.templateError = true
            errors = true
          }
          props.updateUI(nextUI)
          if (!errors && filter(props.ui.fields, (field, index)=> !props.validateField(props, index)).length == 0) {
            if (props.template){
              if(!props.cloneTemplate){
                dispatch(actions.updateTemplate(props.template.template_id, props.ui.name, template, { fields: props.ui.fields, category: props.ui.category }))
              }else{ 
                dispatch(actions.createTemplate(props.ui.name, template, props.id, props.type, { fields: props.ui.fields, category: props.ui.category }))  
              }
            }else{
              dispatch(actions.createTemplate(props.ui.name, template, props.id, props.type, { fields: props.ui.fields, category: props.ui.category }))
            }
          }
        }, true)
      })
      return false
    },

    pasteTemplate: (props, template)=> {
      props.updateUI({
        name: template.name,
        fields: template.attach_json && template.attach_json.fields || [],
        category: template.attach_json && template.attach_json.category ? template.attach_json.category : 'diary'
      })
      props.ui.handlers.insertValue(template.template, undefined, true)
    },

    willMount: (props)=> {
      props.template_id && dispatch(actions.fetchTemplate(props.template_id))
    },

    willUpdate: (props, nextProps)=> {
      if (!props.template && nextProps.template) {
        nextProps.updateUI({
          name: nextProps.template.name,
          fields: nextProps.template.attach_json && nextProps.template.attach_json.fields || [],
          category: nextProps.template.attach_json && nextProps.template.attach_json.category || 'diary'
        })
        if (nextProps.ui.handlers)
          nextProps.ui.handlers.insertValue(nextProps.template.template)
      }

      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.updateUI({ fields: [] })
        nextProps.selectPanel('templates')
        if (nextProps.template_id)
          dispatch(emitAlertMessage({ message: "label:テンプレートを更新しました", name: nextProps.template.name }, "inputSuccess"))
        else
          dispatch(emitAlertMessage("label:テンプレートを作成しました", "inputSuccess"))
      }
    },

    addField: (props, field)=> props.updateUI({ fields: props.ui.fields.concat(field) }),
    updateField: (props, index, field)=> props.updateUI({ fields: props.ui.fields.map((f, i)=> i == index ? field : f)}),
    deleteField: (props, index)=> props.updateUI({ fields: props.ui.fields.filter((f, i)=> i != index)}),
    sortField: (props, fields, fieldsError)=> props.updateUI({ fields, fieldsError }),
    validateField: (props, index)=> {
      let noError = true
      let errors = { name: undefined, options: undefined }
      let fieldsError = props.ui.fieldsError.concat()
      let fields = props.ui.fields.concat()
      let field = fields[index]

      if (field.type == 'new') {
        errors.type = props.t('error:フィールド種別を選択してください')
        noError = false
      }
      if (!field.name) {
        errors.name = props.t('error:フィールド名を入力してください')
        noError = false
      }
      if (field.type == 'dropdown') {
        let options = field.options && filter(field.options.map((option)=> option.trim()), (option)=> option) || []
        field.options = options
        if (options.length < 1) {
          errors.options = props.t('error:フィールドの選択肢を入力してください')
          noError = false
        }
      }

      fieldsError[index] = noError ? undefined : errors
      props.updateUI({ fieldsError, fields })

      return noError
    },
    onChangeCategory: (props, category)=> {
      props.updateUI({ category: category })
    },
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      name: (props)=> cloneTemplate(props.cloneTemplate, props.t('label:コピー'))　|| props.template && props.template.name || '',
      nameError: undefined,
      templateError: undefined,
      handlers: undefined,
      category: (props)=> props.template && props.template.attach_json && props.template.attach_json.category || 'diary',
      fields: (props)=> props.template && props.template.attach_json && props.template.attach_json.fields || [],
      fieldsError: [],
      keyboard: undefined
    }
  }),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/template-form-panel.js